module.exports = __webpack_public_path__ + "img/叠加奖项.6e0c6285.png";